<template>
    <div class='ListTable'>
        <table class="table" :class='ClassObj'>
            <caption>{{caption}}</caption>
            <thead>
                <tr>
                    <th scope="col" v-for='(header, idx) in headers' :key='idx'>{{header}}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for='(item, itIdx) in items' :key='itIdx'>
                    <td v-for='(value, vidx) in item' :key='vidx'>{{item[vidx]}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    export default{
        name: 'ListTable',
        props:['classes','headers','items', 'caption'],
        data(){
            return{
                ClassObj: this.$props.classes
            }
        }
    }
</script>